import dayjs from 'dayjs';
import ShelfController from '../../core/shelf.controller';

class UserInteractionsController extends ShelfController {
    async initialize() {
        if (!this.isAuthenticated) {
            this.navigateLogin();
            return;
        }
        await this.loadSummary(dayjs());
    }

    async loadSummary(date) {
        this.setState({ loading: true, error: null });
        try {
            const formatted = date.format('YYYY-MM-DD');
            const response = await this.data.fetchInteractionSummary(formatted);
            this.setState({
                loading: false,
                summary: response?.summary || [],
                inactiveUsers: response?.inactiveUsers || [],
                totalUsers: response?.totalUsers || 0,
                date: formatted
            });
        } catch (err) {
            this.props.onMessage?.('error', err?.response?.data?.message || err?.message || 'Error al cargar interacciones');
            this.setState({ loading: false, error: true });
        }
    }

    /** Re-runs the last query (error state "Reintentar"). */
    retry() {
        return this.loadSummary(dayjs(this.state.date));
    }

    /** Active / inactive counts and the activity rate for the KPI row. */
    getActivityStats() {
        const { inactiveUsers, totalUsers } = this.state;
        const activeCount = totalUsers - inactiveUsers.length;
        const activePercent = totalUsers > 0 ? Math.round((activeCount / totalUsers) * 100) : 0;
        return { activeCount, activePercent };
    }
}

export default UserInteractionsController;
